import { QuestionBase } from '@app/core/models/question/question-base';

export class CheckboxQuestion extends QuestionBase<string> {
    controlType = 'checkbox';
    type: string;
    options: { key1: Array<{ value: string, classIcon: string, checked: boolean }>,
                key2: Array<{ value: string, classIcon: string, checked: boolean }> };

    constructor(options: any = {}) {
        super(options);
        this.type = options['type'] || 'checkbox';
        this.options = options['options'] || {};
    }
}

export class CheckboxSave extends QuestionBase<string>{
    controlType = 'checkbox';
    type: string;
    options: { key: string, checked: boolean, name: string }[] = [];

    constructor(options: any = {}) {
        super(options);
        this.type = options['type'] || 'checkbox';
        this.options = options['options'] || [];
    }
}


// WEBPACK FOOTER //
// ./src/app/core/models/question/checkbox-question.ts